import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b90aa08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banter-loader\" data-v-1b90aa08><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div><div class=\"banter-loader__box\" data-v-1b90aa08></div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

import { store } from '@/store/store';
import { ComputedRef, Ref, computed, onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  setup(__props) {

const Store = store();

const isClosed:Ref<boolean> = ref(false);
const isAnim:Ref<boolean> = ref(false);

let timeOutVar: number | undefined;

const lockScroll = (ev: boolean): void => {
    if (ev) {
        // Get the current scroll position
        const scrollPosition = window.scrollY;

        // Save the current scroll position
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
    } else {
        const scrollPosition = parseInt(document.body.style.top || '0', 10);
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, Math.abs(scrollPosition));
    }
}

const isNav:ComputedRef<boolean> = computed(() => Store.isNavigate)

watch(isNav, (val) => {
    rerenderMasl(Store.getNavLoaderTime, true)
});

const rerenderMasl = (time: number, anim: boolean): void => {
    if (anim) isAnim.value = true;
    isClosed.value = false;
    lockScroll(true);
    window.clearTimeout(timeOutVar);
    timeOutVar = window.setTimeout(() => {
        isClosed.value = true;
        if (anim) isAnim.value = false;
        lockScroll(false);
        Store.setIsNavigate(false);
    }, time)
}

onMounted(() => {
    rerenderMasl(Store.getLoaderTime, false);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loader center", { 'isClosed': isClosed.value, 'is-anim' : isAnim.value }])
  }, _hoisted_2, 2))
}
}

})